import axios from "axios";
import React from "react";
import { useEffect } from "react";
import REACT_APP from "../../environment";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ViewIMage = ({ id }) => {
    const { t } = useTranslation();
    const qy = document.querySelector.bind(document);
    const [loading, setLoading] = useState(true);

    const getFile = async () => {
        setLoading(true);
        await axios(`${REACT_APP.URL}/api/hrp/v1/core-value/image/${id}`, {
            headers: { Authorization: sessionStorage.getItem("token") },
            responseType: "blob",
        })
            .then((blob) => {
                setLoading(false);
                setTimeout(() => {
                    qy("#v_img").src = window.URL.createObjectURL(blob.data);
                });
            })
            .catch((err) => setLoading(false));
    };

    useEffect(() => {
        getFile();
    }, [id]);

    return (
        <>
            <div className="modal fade" id="viewImage" tabIndex="-1" aria-labelledby="viewImageLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content bg-white">
                        <div className="modal-header py-1">
                            <h5 className="modal-title" id="viewImageLabel">
                                {t("File")}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body file_md img-fluid">
                            {loading ? (
                                <div className="spinner-border text-info my-5" role="status">
                                    <span className="visually-hidden">{t("Loading...")}</span>
                                </div>
                            ) : (
                                <img id="v_img" src="" alt="img" height="750" width="100%" />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewIMage;
